import React from 'react'
import { Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const ThankYouComponent = () => {
  const navigate = useNavigate()

  const handleBackToHome = () => {
    navigate('/')
  }

  return (
    <Container style={{ textAlign: 'center', marginTop: '50px' }}>
      <Typography variant="h4" gutterBottom>
        Спасибо за ваш заказ!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Мы получили ваш заказ и скоро с вами свяжемся.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleBackToHome}>
        Вернуться на главную
      </Button>
    </Container>
  )
}

export default ThankYouComponent
